module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/telecaller/telecaller.component.css
// module id = ./src/app/prospect/telecaller/telecaller.component.css
// module chunks = main